var SCM = SCM || {};

SCM.CmsJumpLinks = (function ($) {
    return {
        init
    };

    function init() {
        const jumpLinkList = $('.js-cms-jumplink-list')[0];
        if (!jumpLinkList) {
            return;
        }

        SCM.Utilities.ScrollOverflow.observe(jumpLinkList);
    }
})(jQuery);
